import { render, staticRenderFns } from "./MoreDetailInfoForm.vue?vue&type=template&id=5a3505c9&"
import script from "./MoreDetailInfoForm.vue?vue&type=script&lang=js&"
export * from "./MoreDetailInfoForm.vue?vue&type=script&lang=js&"
import style0 from "./MoreDetailInfoForm.vue?vue&type=style&index=0&id=5a3505c9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports